export default __webpack_public_path__ + "static/media/1819 spice rack side.40eaa1e6.png";